var map = {
	"./ion-accordion_2.entry.js": [
		16103,
		"common",
		"node_modules_pnpm_ionic_core_7_6_6_node_modules_ionic_core_dist_esm_ion-accordion_2_entry_js"
	],
	"./ion-action-sheet.entry.js": [
		30350,
		"common",
		"node_modules_pnpm_ionic_core_7_6_6_node_modules_ionic_core_dist_esm_ion-action-sheet_entry_js"
	],
	"./ion-alert.entry.js": [
		91126,
		"common",
		"node_modules_pnpm_ionic_core_7_6_6_node_modules_ionic_core_dist_esm_ion-alert_entry_js"
	],
	"./ion-app_8.entry.js": [
		83048,
		"common",
		"node_modules_pnpm_ionic_core_7_6_6_node_modules_ionic_core_dist_esm_ion-app_8_entry_js"
	],
	"./ion-avatar_3.entry.js": [
		15017,
		"node_modules_pnpm_ionic_core_7_6_6_node_modules_ionic_core_dist_esm_ion-avatar_3_entry_js"
	],
	"./ion-back-button.entry.js": [
		23002,
		"common",
		"node_modules_pnpm_ionic_core_7_6_6_node_modules_ionic_core_dist_esm_ion-back-button_entry_js"
	],
	"./ion-backdrop.entry.js": [
		22600,
		"node_modules_pnpm_ionic_core_7_6_6_node_modules_ionic_core_dist_esm_ion-backdrop_entry_js"
	],
	"./ion-breadcrumb_2.entry.js": [
		17898,
		"common",
		"node_modules_pnpm_ionic_core_7_6_6_node_modules_ionic_core_dist_esm_ion-breadcrumb_2_entry_js"
	],
	"./ion-button_2.entry.js": [
		38623,
		"node_modules_pnpm_ionic_core_7_6_6_node_modules_ionic_core_dist_esm_ion-button_2_entry_js"
	],
	"./ion-card_5.entry.js": [
		95416,
		"node_modules_pnpm_ionic_core_7_6_6_node_modules_ionic_core_dist_esm_ion-card_5_entry_js"
	],
	"./ion-checkbox.entry.js": [
		34439,
		"node_modules_pnpm_ionic_core_7_6_6_node_modules_ionic_core_dist_esm_ion-checkbox_entry_js"
	],
	"./ion-chip.entry.js": [
		23240,
		"node_modules_pnpm_ionic_core_7_6_6_node_modules_ionic_core_dist_esm_ion-chip_entry_js"
	],
	"./ion-col_3.entry.js": [
		26684,
		"node_modules_pnpm_ionic_core_7_6_6_node_modules_ionic_core_dist_esm_ion-col_3_entry_js"
	],
	"./ion-datetime-button.entry.js": [
		51508,
		"default-node_modules_pnpm_ionic_core_7_6_6_node_modules_ionic_core_dist_esm_data-775093f5_js",
		"node_modules_pnpm_ionic_core_7_6_6_node_modules_ionic_core_dist_esm_ion-datetime-button_entry_js"
	],
	"./ion-datetime_3.entry.js": [
		25125,
		"default-node_modules_pnpm_ionic_core_7_6_6_node_modules_ionic_core_dist_esm_data-775093f5_js",
		"common",
		"node_modules_pnpm_ionic_core_7_6_6_node_modules_ionic_core_dist_esm_ion-datetime_3_entry_js"
	],
	"./ion-fab_3.entry.js": [
		90863,
		"common",
		"node_modules_pnpm_ionic_core_7_6_6_node_modules_ionic_core_dist_esm_ion-fab_3_entry_js"
	],
	"./ion-img.entry.js": [
		97399,
		"node_modules_pnpm_ionic_core_7_6_6_node_modules_ionic_core_dist_esm_ion-img_entry_js"
	],
	"./ion-infinite-scroll_2.entry.js": [
		63547,
		"common",
		"node_modules_pnpm_ionic_core_7_6_6_node_modules_ionic_core_dist_esm_ion-infinite-scroll_2_entry_js"
	],
	"./ion-input.entry.js": [
		24688,
		"default-node_modules_pnpm_ionic_core_7_6_6_node_modules_ionic_core_dist_esm_form-controller-5-212d74",
		"common",
		"node_modules_pnpm_ionic_core_7_6_6_node_modules_ionic_core_dist_esm_ion-input_entry_js"
	],
	"./ion-item-option_3.entry.js": [
		45933,
		"common",
		"node_modules_pnpm_ionic_core_7_6_6_node_modules_ionic_core_dist_esm_ion-item-option_3_entry_js"
	],
	"./ion-item_8.entry.js": [
		60850,
		"common",
		"node_modules_pnpm_ionic_core_7_6_6_node_modules_ionic_core_dist_esm_ion-item_8_entry_js"
	],
	"./ion-loading.entry.js": [
		39564,
		"common",
		"node_modules_pnpm_ionic_core_7_6_6_node_modules_ionic_core_dist_esm_ion-loading_entry_js"
	],
	"./ion-menu_3.entry.js": [
		87019,
		"common",
		"node_modules_pnpm_ionic_core_7_6_6_node_modules_ionic_core_dist_esm_ion-menu_3_entry_js"
	],
	"./ion-modal.entry.js": [
		62857,
		"common",
		"node_modules_pnpm_ionic_core_7_6_6_node_modules_ionic_core_dist_esm_ion-modal_entry_js"
	],
	"./ion-nav_2.entry.js": [
		8864,
		"node_modules_pnpm_ionic_core_7_6_6_node_modules_ionic_core_dist_esm_ion-nav_2_entry_js"
	],
	"./ion-picker-column-internal.entry.js": [
		26697,
		"common",
		"node_modules_pnpm_ionic_core_7_6_6_node_modules_ionic_core_dist_esm_ion-picker-column-interna-78e969"
	],
	"./ion-picker-internal.entry.js": [
		37172,
		"node_modules_pnpm_ionic_core_7_6_6_node_modules_ionic_core_dist_esm_ion-picker-internal_entry_js"
	],
	"./ion-popover.entry.js": [
		16673,
		"common",
		"node_modules_pnpm_ionic_core_7_6_6_node_modules_ionic_core_dist_esm_ion-popover_entry_js"
	],
	"./ion-progress-bar.entry.js": [
		98873,
		"node_modules_pnpm_ionic_core_7_6_6_node_modules_ionic_core_dist_esm_ion-progress-bar_entry_js"
	],
	"./ion-radio_2.entry.js": [
		67474,
		"common",
		"node_modules_pnpm_ionic_core_7_6_6_node_modules_ionic_core_dist_esm_ion-radio_2_entry_js"
	],
	"./ion-range.entry.js": [
		36925,
		"common",
		"node_modules_pnpm_ionic_core_7_6_6_node_modules_ionic_core_dist_esm_ion-range_entry_js"
	],
	"./ion-refresher_2.entry.js": [
		40941,
		"common",
		"node_modules_pnpm_ionic_core_7_6_6_node_modules_ionic_core_dist_esm_ion-refresher_2_entry_js"
	],
	"./ion-reorder_2.entry.js": [
		5510,
		"common",
		"node_modules_pnpm_ionic_core_7_6_6_node_modules_ionic_core_dist_esm_ion-reorder_2_entry_js"
	],
	"./ion-ripple-effect.entry.js": [
		66292,
		"node_modules_pnpm_ionic_core_7_6_6_node_modules_ionic_core_dist_esm_ion-ripple-effect_entry_js"
	],
	"./ion-route_4.entry.js": [
		61322,
		"node_modules_pnpm_ionic_core_7_6_6_node_modules_ionic_core_dist_esm_ion-route_4_entry_js"
	],
	"./ion-searchbar.entry.js": [
		13745,
		"common",
		"node_modules_pnpm_ionic_core_7_6_6_node_modules_ionic_core_dist_esm_ion-searchbar_entry_js"
	],
	"./ion-segment_2.entry.js": [
		87376,
		"common",
		"node_modules_pnpm_ionic_core_7_6_6_node_modules_ionic_core_dist_esm_ion-segment_2_entry_js"
	],
	"./ion-select_3.entry.js": [
		40596,
		"common",
		"node_modules_pnpm_ionic_core_7_6_6_node_modules_ionic_core_dist_esm_ion-select_3_entry_js"
	],
	"./ion-spinner.entry.js": [
		24149,
		"common",
		"node_modules_pnpm_ionic_core_7_6_6_node_modules_ionic_core_dist_esm_ion-spinner_entry_js"
	],
	"./ion-split-pane.entry.js": [
		93567,
		"node_modules_pnpm_ionic_core_7_6_6_node_modules_ionic_core_dist_esm_ion-split-pane_entry_js"
	],
	"./ion-tab-bar_2.entry.js": [
		1286,
		"common",
		"node_modules_pnpm_ionic_core_7_6_6_node_modules_ionic_core_dist_esm_ion-tab-bar_2_entry_js"
	],
	"./ion-tab_2.entry.js": [
		56270,
		"node_modules_pnpm_ionic_core_7_6_6_node_modules_ionic_core_dist_esm_ion-tab_2_entry_js"
	],
	"./ion-text.entry.js": [
		5945,
		"node_modules_pnpm_ionic_core_7_6_6_node_modules_ionic_core_dist_esm_ion-text_entry_js"
	],
	"./ion-textarea.entry.js": [
		98092,
		"default-node_modules_pnpm_ionic_core_7_6_6_node_modules_ionic_core_dist_esm_form-controller-5-212d74",
		"node_modules_pnpm_ionic_core_7_6_6_node_modules_ionic_core_dist_esm_ion-textarea_entry_js"
	],
	"./ion-toast.entry.js": [
		42463,
		"common",
		"node_modules_pnpm_ionic_core_7_6_6_node_modules_ionic_core_dist_esm_ion-toast_entry_js"
	],
	"./ion-toggle.entry.js": [
		26326,
		"common",
		"node_modules_pnpm_ionic_core_7_6_6_node_modules_ionic_core_dist_esm_ion-toggle_entry_js"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 61535;
module.exports = webpackAsyncContext;